@tailwind base;
@tailwind components;
@tailwind utilities;

@layer base {
  * {
    box-sizing: border-box;
  }

  :root {
    color-scheme: dark;
  }

  body {
    @apply bg-gray-950 text-gray-100 font-sans;
  }

  /* Scrollbar */
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  ::-webkit-scrollbar-track {
    @apply bg-gray-900;
  }
  ::-webkit-scrollbar-thumb {
    @apply bg-gray-700 rounded;
  }
}

@layer utilities {
  .tabular-nums {
    font-variant-numeric: tabular-nums;
  }
}
